
<template>
  <div>
    <header-group>
    </header-group>
    <div>
    <img src="../assets/1639745877778799.jpg" style="width: 100%; display:block">
    </div>
    <breadcrumb :breadcrumbs=breadcrumbs :button="button">
    </breadcrumb>

    <div class="index-news">
      <div class="index-title">
        <p class="t1" style="color: black;">行业咨询</p>
        <div class="displayF" style="margin-top: 15px">
          <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
        </div>
        <p style="text-align: center; font-size: 24px; color: #F00;">
          北京执享信息科技有限公司<br><br>
          地址：北京市朝阳区姚家园路105号1号楼4层503室1号<br><br>
          电话：18513110521<br><br>
          邮箱：zhaoyao@zx-techgroup.com
        </p>
        <img src="../assets/map.png" width="700" height="400" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import HeaderGroup from "@/components/HeaderGroup.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Bottom from "@/components/Bottom.vue";

export default {
  name: 'about',
  components: {Bottom, Breadcrumb,HeaderGroup},
  data() {
    return {
      breadcrumbs: [{name:'首页',path:'/'},{name:'联系我们',path:'/about'}],
      button:[{name:'关于我们',url:'/about'},{name:'联系我们',url:'/about'}]
    }
  }


}

</script>
<style scoped>

.index-news {
  padding: 10px 0 70px 0;
  background: white;
}
.index-title {
  padding: 60px 0;
  text-align: center;
  align-items: center;
  position: relative;
  line-height: 30px
}

.displayF {
  display: flex;
  justify-content: center;
}

.t1 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px
}

</style>